import { render, staticRenderFns } from "./ContentConduiteAttachments.vue?vue&type=template&id=1cd4bc22"
import script from "./ContentConduiteAttachments.vue?vue&type=script&lang=js"
export * from "./ContentConduiteAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports